const AccountAPI = {
  readHash(hash) {
    return new Promise((resolve, reject) => {
      const response = fetch(' /static/api/readhash.php', {
        method: 'POST',
        body: JSON.stringify({
          'hash': hash,
        })
      })
        .then(response => response.json())
      resolve(response)
    })
  },
  checkAccount(username, password) {
    return new Promise((resolve, reject) => {
      const response = fetch(' /static/api/account_check.php', {
        method: 'POST',
        body: JSON.stringify({ 'username': username, 'password': password })
      })
        .then(response => response.json())
    })
  },
  createSubAccount(province_code, city_code, barangay_code, address, email_address, login_id, token) {
    return new Promise((resolve, reject) => {
      const response = fetch(' /static/api/account_create_sub.php', {
        method: 'POST',
        body: JSON.stringify({ 'province_code': province_code, 'city_code': city_code, 'barangay_code': barangay_code, 'address': address, 'email_address': email_address, 'login_id': login_id, 'token': token })
      })
        .then(response => response.json())
      resolve(response)
    })
  },
  login(username, password) {
    return new Promise((resolve, reject) => {
      const response = fetch(' /static/api/login.php', {
        method: 'POST',
        body: JSON.stringify({ 'username': username, 'password': password })
      })
        .then(response => response.json())
        .then(response => {
          if (response.login_id) {
            var new_response = {
              status: 'success',
              remarks: response.remarks,
              login_id: response.login_id,
              token: response.token,
              address_list: response.address_list
            }

            resolve(new_response)
          } else {

            resolve(response)
          }
        })
    })
  },
  logout(token) {
    return new Promise((resolve, reject) => {
      const response = fetch(' /static/api/logout.php', {
        method: 'POST',
        body: JSON.stringify({
          't': token,
        })
      })
        .then(response => response.json())
      resolve(response)
    })
  },
  register(first_name, last_name, position, tel_number, mobile_number, email_address, referral_code, marketing_consent, privacy_policy_consent, registered_business_name, trader_name, address, province, city, barangay, sec_registration_num, dti_registration_num, tin_num, channel_classification, links, doc1, doc2, doc3, uuid) {

    return new Promise((resolve, reject) => {
      const response = fetch(' /static/api/register.php', {
        method: 'POST',
        body: JSON.stringify({
          'first_name': first_name,
          'last_name': last_name,
          'position': position,
          'tel_number': tel_number,
          'mobile_number': mobile_number,
          'email_address': email_address,
          'marketing_consent': marketing_consent,
          'privacy_policy_consent': privacy_policy_consent,
          'registered_business_name': registered_business_name,
          'trader_name': trader_name,
          'address': address,
          'province': province,
          'city': city,
          'barangay': barangay,
          'sec_registration_num': sec_registration_num,
          'dti_registration_num': dti_registration_num,
          'tin_num': tin_num,
          "channel_classification": channel_classification, //New Added Social Media Links
          "links": links, //New Added Social Media Links
          "doc1": doc1,
          "doc2": doc2,
          "doc3": doc3,
          'uuid': uuid
        })
      })
        .then(response => response.json())
      resolve(response)
    })
  },

  customerClassification() {
    return new Promise((resolve, reject) => {
      const response = fetch(' /static/api/customer_classification.php', {
        method: 'POST'
      })
        .then(response => response.json())
      resolve(response)
    })
  },



  submitAttachments(attachment_type, attachment_filename, attachment_base64, uuid, upload_type) {
    return new Promise((resolve, reject) => {

      let formData = new FormData();

      formData.append('attachment_type', attachment_type);
      formData.append('attachment_filename', attachment_filename);
      formData.append('attachment_base64', attachment_base64);
      formData.append('uuid', uuid);
      formData.append('upload_type', upload_type);

      const response = fetch(' /static/api/sendfile.php', {
        method: 'POST',
        // headers: {

        //     'Content-Type': 'multipart/form-data'
        // },
        body: formData
      })
        .then(response => response.json())
      resolve(response)
    })
  },
  accountInfo(token, customer_id) {
    return new Promise((resolve, reject) => {
      const response = fetch(' /static/api/account_info.php', {
        method: 'POST',
        body: JSON.stringify({
          't': token,
          'customer_id': customer_id
        })
      })
        .then(response => response.json())
        .then(response => {
          if (response.data) {
            response.data = response.data;
            return response;
          }
          else {
            return response;
          }

        })
      resolve(response)
    })
  },
  updateAccountInfo(login_id, token, customer_id, registered_business_name, trader_name, sec_registration_num, dti_registration_num, tin_num, first_name, last_name, position, tel_number, mobile_number, email_address, channel_classification, links, doc1, doc2, doc3) {
    return new Promise((resolve, reject) => {
      const response = fetch(' /static/api/update_account_info.php', {
        method: 'POST',
        body: JSON.stringify({
          'login_id': login_id,
          'token': token,
          'customer_id': customer_id,
          'registered_business_name': registered_business_name,
          'trader_name': trader_name,
          'sec_registration_num': sec_registration_num,
          'dti_registration_num': dti_registration_num,
          'tin_num': tin_num,
          'first_name': first_name,
          'last_name': last_name,
          'position': position,
          'tel_number': tel_number,
          'mobile_number': mobile_number,
          'email_address': email_address,
          'channel_classification': channel_classification, // New added
          'links': links, // New added
          'doc1': doc1,
          'doc2': doc2,
          'doc3': doc3,
        })
      })
        .then(response => response.json())
      resolve(response)
    })
  },
  forgotPassword(email_address) {
    return new Promise((resolve, reject) => {
      const response = fetch(' /static/api/forgot_password.php', {
        method: 'POST',
        body: JSON.stringify({
          'email_address': email_address,
        })
      })
        .then(response => response.json())
      resolve(response)
    })
  },
  verifyResetHash(resethash) {
    return new Promise((resolve, reject) => {
      const response = fetch(' /static/api/verify_resethash.php', {
        method: 'POST',
        body: JSON.stringify({
          'resethash': resethash,
        })
      })
        .then(response => response.json())
      resolve(response)
    })
  },
  changePassword(new_password, confirm_password, reset_password_id, reset_password_token) {
    // This is a change password thru forgot password/change password link
    return new Promise((resolve, reject) => {
      const response = fetch(' /static/api/change_password.php', {
        method: 'POST',
        body: JSON.stringify({
          'new_password': new_password,
          'confirm_password': confirm_password,
          'reset_password_id': reset_password_id,
          'reset_password_token': reset_password_token,
        })
      })
        .then(response => response.json())
      resolve(response)
    })
  },
  accountChangePassword(login_id, token, current_password, new_password, confirm_password) {
    // This is a change password thru an account
    return new Promise((resolve, reject) => {
      const response = fetch(' /static/api/account_change_password.php', {
        method: 'POST',
        body: JSON.stringify({
          'login_id': login_id,
          'token': token,
          'current_password': current_password,
          'new_password': new_password,
          'confirm_password': confirm_password,
        })
      })
        .then(response => response.json())
      resolve(response)
    })
  },
  ping(login_id, token) {
    return new Promise((resolve, reject) => {
      const response = fetch(' /static/api/ping.php', {
        method: 'POST',
        body: JSON.stringify({
          'login_id': login_id,
          'token': token,
        })
      })
        .then(response => response.json())
      resolve(response)
    })
  },
  myVouchers(login_id, token) {
    return new Promise((resolve, reject) => {
      const response = fetch(' /static/api/account_voucher.php', {
        method: 'POST',
        body: JSON.stringify({
          'login_id': login_id,
          'token': token,
        })
      })
        .then(response => response.json())
      resolve(response)
    })
  },
  myOrders(login_id, token, from, to) {
    return new Promise((resolve, reject) => {
      const response = fetch(' /static/api/account_orders.php', {
        method: 'POST',
        body: JSON.stringify({
          'login_id': login_id,
          'token': token,
          'from': from,
          'to': to,
        })
      })
        .then(response => response.json())
      resolve(response)
    })
  },
  getOrderDetails(login_id, token, order_id) {
    return new Promise((resolve, reject) => {
      const response = fetch(' /static/api/account_order_details.php', {
        method: 'POST',
        body: JSON.stringify({
          'login_id': login_id,
          'token': token,
          'order_id': order_id,
        })
      })
        .then(response => response.json())
      resolve(response)
    })
  },
  myCart(login_id, token, barangay_code, change_merchant = true) {
    return new Promise((resolve, reject) => {
      const response = fetch(' /static/api/account_cart.php', {
        method: 'POST',
        body: JSON.stringify({
          'login_id': login_id,
          'token': token,
          'barangay_code': barangay_code,
          'change_merchant': change_merchant
        })
      })
        .then(response => response.json())
      resolve(response)
    })
  },
  addToCart(sku_id, quantity, login_id, token) {
    return new Promise((resolve, reject) => {
      const response = fetch(' /static/api/account_add_cart.php', {
        method: 'POST',
        body: JSON.stringify({
          'sku_id': sku_id,
          'quantity': quantity,
          'login_id': login_id,
          'token': token,
        })
      })
        .then(response => response.json())
      resolve(response)
    })
  },
  updateCart(sku_id, quantity, login_id, token) {
    return new Promise((resolve, reject) => {
      const response = fetch(' /static/api/account_update_cart.php', {
        method: 'POST',
        body: JSON.stringify({
          'sku_id': sku_id,
          'quantity': quantity,
          'login_id': login_id,
          'token': token,
        })
      })
        .then(response => response.json())
      resolve(response)
    })
  },
  removeFromCart(sku_id, quantity, login_id, token) {
    return new Promise((resolve, reject) => {
      const response = fetch(' /static/api/account_delete_cart.php', {
        method: 'POST',
        body: JSON.stringify({
          'sku_id': sku_id,
          'quantity': quantity,
          'login_id': login_id,
          'token': token,
        })
      })
        .then(response => response.json())
      resolve(response)
    })
  },
  getRegisterId() {
    return new Promise((resolve, reject) => {
      const response = fetch(' /static/api/rid.php', {
        method: 'GET',
      })
        .then(response => response.json())
      resolve(response)
    })
  },




}
export default AccountAPI



// WEBPACK FOOTER //
// ./src/api/account.js